/* eslint-disable typescript-sort-keys/string-enum */var Widths;
(function (Widths) {
  Widths["None"] = '';
  Widths["Xxsmall"] = 'xxsmall';
  Widths["Xsmall"] = 'xsmall';
  Widths["Small"] = 'small';
  Widths["Medium"] = 'medium';
  Widths["Large"] = 'large';
  Widths["Xlarge"] = 'xlarge';
  Widths["Xxlarge"] = 'xxlarge';
})(Widths || (Widths = {}));
export { Widths };